import Vue from 'vue'

import TopPageSidebar from '@/top/components/TopPageSidebar.vue'
import TopPageMain from '@/top/components/TopPageMain.vue'
import TopPageCarousels from '@/top/components/TopPageCarousels.vue'
import IeDeprecatedAlert from '@/top/components/IeDeprecatedAlert.vue'

import { Article, Carousel, TopProductItem, TopProducts } from '@/top/types'
import { getJsonData } from '@/common/utils/dom'
import { MaxQuantityPrice } from '@/common/types/maxQuantityPrice'
import { Announcement } from '@/common/types/announcements'
import { browser } from '@/common/userAgent'
import { app, data } from '@/top/config/selectors'
import { ProductCategory } from '@/model/productCategory'

import './main.entry.scss'
import { formatCurrencyJP } from '@/common/filter'

const flagTopSearch = getJsonData(data.flagTopSearch)
// eslint-disable-next-line @typescript-eslint/ban-types
const carouselContents: Array<Carousel> = getJsonData(data.carouselContents)
const brandItems: Array<Carousel> = getJsonData(data.brandItems)
const productCategories: Array<ProductCategory> = getJsonData(
  data.productCategories
)

const initCarousel = () => {
  const mountEl = document.querySelector(app.carouselMountEl)
  const containerEl = document.querySelector(app.carouselContainerEl)

  if (!mountEl || !containerEl) {
    return
  }
  if (carouselContents.length === 0) {
    containerEl.classList.add('is-hide')
    return
  }

  new Vue({
    render: h => h(TopPageCarousels, { props: { carouselContents } })
  }).$mount(mountEl)
}

const initTopMain = () => {
  const mountEl = document.querySelector(app.topMainMountEl)
  const articlesData: Article[] = getJsonData(data.articles)
  const announcementsData: Announcement[] = getJsonData(data.announcements)
  const historyProducts: TopProductItem[] = getJsonData(data.viewedProducts)
  const topProducts: TopProducts[] = getJsonData(data.topProducts)
  const maxQuantityPrice: MaxQuantityPrice = getJsonData(data.maxQuantityPrice)

  if (!mountEl) return

  Vue.filter('formatCurrencyJP', formatCurrencyJP)

  new Vue({
    render: h =>
      h(TopPageMain, {
        props: {
          productCategories,
          articlesData,
          announcementsData,
          maxQuantityPrice,
          flagTopSearch,
          historyProducts,
          topProducts
        }
      })
  }).$mount(mountEl)
}

const initTopSidebar = () => {
  const mountEl = document.querySelector(app.topSideBarMountEl)

  if (!mountEl) return

  new Vue({
    render: h => h(TopPageSidebar, { props: { productCategories, brandItems} })
  }).$mount(mountEl)
}

const ieDeprecatedAlert = () => {
  const mountEl = document.querySelector(app.ieDeprecatedAlertEl)
  if (!mountEl) return

  new Vue({
    render: h => h(IeDeprecatedAlert)
  }).$mount(mountEl)
}

initCarousel()
initTopMain()
initTopSidebar()
if (browser.isIE11) ieDeprecatedAlert()
